var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Untie"},[_c('Header',{attrs:{"msg":"订单绑定"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }